import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-form_ico_bank",
  "use": "icon-form_ico_bank-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-form_ico_bank\"><path d=\"M512 128L64 362.667v64h896v-64L512 128zM576 512h85.333v320H576V512zM362.667 512H448v320h-85.333V512zM789.333 512h85.334v320h-85.334V512zM149.333 512h85.333v320h-85.333V512z\" p-id=\"12770\" fill=\"#ffffff\" /><path d=\"M64 832h896v64H64v-64z\" p-id=\"12771\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol